import type { IconProps } from "../types";

/**
 * Bath: registry 独自のバスルームアイコン。
 * lucide `Bath` ではなく service-icon-registry.ts の custom svgContent を逐語再現。
 */
export const Bath = ({
	size = 24,
	color = "currentColor",
	strokeWidth = 2,
	className,
	"aria-label": ariaLabel,
}: IconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke={color}
		strokeWidth={strokeWidth}
		strokeLinecap="round"
		strokeLinejoin="round"
		className={className}
		role={ariaLabel ? "img" : undefined}
		aria-label={ariaLabel}
		aria-hidden={ariaLabel ? undefined : true}
	>
		<path d="M4 12h16a1 1 0 0 1 1 1v3a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4v-3a1 1 0 0 1 1-1ZM6 12V5a2 2 0 0 1 2-2h3v2.25" />
	</svg>
);
